import UploadFiles from 'components/Form/UploadFiles';
import React, { useState, useEffect, ChangeEvent } from 'react';
import i18n from '../../../translate/i18n';
import TextareaEditor from '../../Form/TextareaEditor';

interface TypeProps {
  data: any,
  setData: Function
}

export default function Pesquisas({ data, setData }: TypeProps) {

  const [redesSociais, setRedesSociais] = useState<any>('');

  const [relato, setRelato] = useState<string>('');
  const [isMounted, setIsMounted] = useState(true)


  useEffect(() => {
    async function setInitialData() {
      if (data?.redesSociais) {
        await setRedesSociais(data?.redesSociais)
      }
      if (data?.redesSociais?.relato) {
        await setRelato(data?.redesSociais?.relato)

      }
      setIsMounted(false)
    }
    setInitialData()
  }, [])

  useEffect(() => {
    if (!isMounted) {
      relatoAutomatico()
    }

  }, [redesSociais])

  useEffect(() => {
    setData({ ...data, 'redesSociais': { ...redesSociais, relato } })
  }, [redesSociais, relato])


  const relatoAutomatico = () => {

    let relatoNew = 'Foram analisadas as redes: '
    relatoNew += redesSociais?.facebook ? 'Facebook, ' : '';
    relatoNew += redesSociais?.instagram ? 'Instagram, ' : '';
    relatoNew += redesSociais?.google ? 'Google, ' : '';
    relatoNew += redesSociais?.youtube ? 'Youtube, ' : '';
    relatoNew += redesSociais?.twitter ? 'Twitter, ' : '';
    relatoNew += redesSociais?.outros ? 'Outros, ' : '';
    setRelato(relatoNew);
  }

  //atualiza variavel com dados dos checkbox
  const handleCheck = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setRedesSociais({ ...redesSociais, [name]: checked });
  }


  return (

    <div className='container-box'>
      <h5>{i18n.t<string>('edit.social networks')}</h5>
      <hr />
      <form>
        <div className="field">
          <label htmlFor="label">Redes Sociais:</label>
          <label className='checkbox'>
            <input
              type='checkbox'
              name='facebook'
              checked={redesSociais.facebook || false}
              onClick={(event: any) => { handleCheck(event) }}
            />Facebook
                  </label>
          <label className='checkbox'>
            <input
              type='checkbox'
              name='instagram'
              checked={redesSociais.instagram || false}
              onClick={(event: any) => { handleCheck(event) }}
            />Instagram
                  </label>
          <label className='checkbox'>
            <input
              type='checkbox'
              name='twitter'
              checked={redesSociais.twitter || false}
              onClick={(event: any) => { handleCheck(event) }}
            />Twitter
                  </label>
          <label className='checkbox'>
            <input
              type='checkbox'
              name='google'
              checked={redesSociais.google || false}
              onClick={(event: any) => { handleCheck(event) }}
            />Google
                  </label>
          <label className='checkbox'>
            <input
              type='checkbox'
              name='youtube'
              checked={redesSociais.youtube || false}
              onClick={(event: any) => { handleCheck(event) }}
            />Youtube
          </label>
          <label className='checkbox'>
            <input
              type='checkbox'
              name='outros'
              checked={redesSociais.outros || false}
              onClick={(event: any) => { handleCheck(event) }}
            />Outros
          </label>
        </div>

        <TextareaEditor
          name="relato"
          label="Relato"
          placeholder={'Relato'}
          data={relato || ''}
          setData={(value: string) => { setRelato(value) }}
        />
        {
          data.id &&
          <UploadFiles
            name="images"
            label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
            osId={data?.id}
            etapa={'redes-sociais'}
          />
        }
      </form>
    </div>
  )
}
